import styled, { css, keyframes } from "styled-components";
import ModalBootstrap from "react-bootstrap/Modal";
import { BaseButton } from '~/components/layout/Buttons';

const toEmerge = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`
const disappear = keyframes`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const Background = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width:100%;
  height:100%;
  background: rgba(0, 0, 0, 0.3);
  position:fixed;
  top:0;
  left:0;
  z-index:995;
  transition: max-height 0.5s;
  ${({isShow}) => isShow
    ? css `
      animation: 0.5s ${toEmerge} ease-out;
      max-height:100%;

    `: css `
      animation: 0.5s ${disappear} ease-out;
      max-height: 0;
    `
  }

`
export const Container = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: all 0.4s;
 ${({isShow}) => isShow
    ? css `
      transform: translateY(0);
      max-height: 100%;
    `: css `
      position:absolute;
      transform: translateY(-500%);
      max-height:0;
    `
  }

`

export const ModalContent = styled.div`
  overflow: auto;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 15px;
  padding:1.5rem;
  max-width:500px;

  ${({isShow}) => !isShow && css`
    position:relative;
    top: -100px;
  `}

  @media (max-width: 500px){
    width:90%;
  }

  form{
    width: 100%;
  }
`;

export const Title = styled.h2`
  color: #000FFF;
  font-size: 1.125rem;
  font-weight: bold;
  line-height: 1;
  margin-bottom:0;

  @media (min-width: 500px){
    font-size: 1rem;
  }
`
export const CloseIcon = styled.span`
  font-size: .875rem;
  color: #B9B9B9;
  cursor: pointer;
`;
export const CameraIcon = styled.span`
  font-size: 1.2rem;
  color: #FFF;
  cursor: pointer;
`;

const ButtonStyle = css`
 ${BaseButton}
  color: #FFF;
  font-weight: bold;
  border: none;
  box-shadow: 0px 3px 6px #0000004D;

  @media (max-width: 500px){
    font-size: 1rem;
  }
`

export const Button = styled.button`
 ${ButtonStyle}
`
export const InputFile = styled.label`
 ${ButtonStyle}
  background:#000FFF;
  cursor: pointer;
  text-align: center;
  font-size: 1.2rem;
  margin:0;
  input {
    display:none;
  }
`

export const Attachment = styled.div`
  margin-top: 1.5rem;
  background: #F7F7F7;
  border: 1px solid #70707079;
  border-radius: 9px;

  display:flex;
  align-items: center;
  justify-content: space-between;

  padding:0.3rem 0.5rem;

  div{

    span{

      color:#000FFF;
      font-size: .875rem;
      margin-bottom:0;

      + span{
        margin-left: 8px;
        color:#5A5A5A;
      }

      @media (max-width: 500px){
        font-size: 0.6rem;
      }
    }
  }

  button{
    border: none;
    background: none;
  }

  + div {
    margin-top:0.7rem;
  }

  ${({ overweight }) => overweight && css`
      border-color: #FF0000;

      div{

        span{
          color: #FF0000;

          + span{
            color: #FF0000;
          }
        }
      }
  `}
`
export const ButtonSuspense = styled.button`
  border: none;
  background: none;
  padding: none;
  //position: absolute;
  align-self: flex-end;
  //transform: translate(100%, -200%);

  ${CloseIcon}{
    font-size: 2rem;
    color: #FFF;
  }
`

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  width: 100%;
  margin-bottom:1rem;

  @media (max-width: 500px){
    flex-direction: column;
    align-items: center;
  }

  div{
    border: 1px solid #7070704A;
    border-radius: 9px;
    padding: 0.3rem 0.6rem;
    display: flex;
    align-items: center;

    @media (max-width: 500px){
      margin-top:8px;
    }

    ${Title}{
      font-size: 1rem;

      @media (min-width: 500px){
        font-size: 1rem;
      }
    }
  }
`

export const Alert = styled.span`
  display: block;
  color: #FF0000;
  font-size: 0.75rem;
  margin-top: 0.5rem;

  ${({ ml }) => ml && css`
    padding-left: 8px;
  `}

  + {

    ${Attachment}{
      margin-top:0.7rem;
    }
  }
`

export const Main = styled.main`
  display:flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 1.25rem;

  p{
    font-size: 0.825rem;
  }

  aside{
    display: flex;
    align-items: center;

    ${Button}{
      margin-left: 8px;
      width: 60px;
      background: #000FFF;
      @media (min-width:771px){
        display: none;
      }
    }

  }

  textarea{
    margin-top: 1.5rem;
    padding: 1rem .8rem;
    border: 1px solid #D5D5D5;
    border-radius: 10px;
    resize: none;
  }


`


export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  ${Button}{
    width:50%;
    background: #8FC24C;
    max-height: 40px;

    &:disabled{
      filter: grayscale(55%);
      cursor: not-allowed;
    }
  }
`

export const Modal = styled(ModalBootstrap)`
  &.modal-contrato .modal-content{
    width:100%;
    padding:1rem;
    margin-left: 0;
    bottom:0;

    @media (max-width: 770px){
      border-radius: 0.8rem;
    }
  }

  &.fade{
    display: flex !important;
    align-items: center;
  }

  &.modal-open .modal-dialog{
    display: block;
  }

`
